export default "__VITE_ASSET__eaf98712__"